import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CommInfo, type CommInfoHandle } from "@/components/profile/CommInfo";
import { Button } from "@/components/ui/Button";
import { WizardActionsBar } from "@/components/wizard/WizardActionsBar";
import { useTaskStore } from "@/store/task";
import { markIntakeStepDone } from "@/store/intakeProgress";
import { backFromCommPrefs } from "@/utils/intakeResume";

/**
 * Communication Preferences wizard step.
 * Wraps the existing CommInfo component with Back / Save and Continue navigation.
 */
export function CommPrefsWizardPage() {
  const navigate = useNavigate();
  const commRef = useRef<CommInfoHandle>(null);
  const [saving, setSaving] = useState(false);
  const wizardSteps = useTaskStore((s) => s.wizardSteps);

  const handleContinue = async () => {
    setSaving(true);
    try {
      const ok = await commRef.current?.save();
      if (ok !== false) {
        markIntakeStepDone("commPrefs");
        navigate("/complaint/financial-responsibility");
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="wizard-page w-full min-h-0">
      <div className="wizard-page__content p-2 sm:p-4">
        <h2 className="mb-4 text-lg font-bold text-healthsource-dark">
          Communication Preferences
        </h2>
        <CommInfo ref={commRef} showSubmitButton={false} />
      </div>

      <WizardActionsBar>
        <Button
          type="button"
          variant="outline"
          onClick={() => navigate(backFromCommPrefs(wizardSteps))}
        >
          Back
        </Button>
        <Button type="button" onClick={handleContinue} disabled={saving}>
          {saving ? "Saving…" : "Save and Continue"}
        </Button>
      </WizardActionsBar>
    </div>
  );
}
